export const fr = {
  // Login
  "login.text.welcome": "Bienvenue sur l’espace",
  "login.text.description": "Merci de vous connecter avec vos identifiants pour accéder à votre espace personnel.",
  "login.id.placeholder": "Identifiant",
  "login.password.placeholder": "Mot de passe",
  "login.button.connect": "Se connecter",

  Worker_State_Enabled: "Actif",
  Worker_State_Disabled: "Inactif",

  WorkerList_Title: "Équipe",
  WorkerListPage_FullName: "Nom complet",
  WorkerListPage_State: "État",

  Toast_TitleError: "Erreur",
  Toast_TitleSuccess: "Succès",
  Toast_TitleInfo: "Information",
  Toast_GenericSuccessUpdateData: "Les données ont bien été mises à jour.",
  "edit.quit.confirmation": "Quitter cette page sans enregistrer les modifications ?",

  "header.name": "Équipe",
  "header.logout": "Déconnecter",

  WorkerInfo_FullName_Label: "Nom complet de l'utilisateur",
  WorkerInfo_Login_Label: "Login",
  WorkerInfo_Id_Label: "Identifiant Md2",
  CommonInfo_Title: "Infos",
  WorkerInfo_State_Label: "État",
  CommonInfo_SaveButtonTitle: "Enregistrer",
  CommonInfo_PasswordButtonTitle: "Générer un mot de passe",

  Password_Modal_Title: "Nouveau mot de passe",
  Password_Modal_Description: "Ce mot de passe est valable 15 minutes",
};
